import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import React, { useEffect, useRef, useState } from "react";

import { DatePicker } from "antd";
import Loading from "../../loader/loader.js";
import NkHeader from "../../../common/nkheader.js";
import NkTable from "../nktable.js";
import { getAllRejectedList } from "../utils.js";
import moment from "moment";
import { useHistory } from "react-router-dom";

const Rejected = () => {
  const [filterValues, setFilterValues] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);
  const [searchBy, setSearchBy] = useState("mobile");
  const [searchByValue, setSearchByValue] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState();
  const [allUserList, setAllUserList] = useState([]);
  const [allUserListExcel, setallUserListExcel] = useState([]);
  const [sizeShow, setSizeShow] = useState();

  const buttonRef = useRef(null);
  const csvLink = useRef();
  const history = useHistory();

  const request = {
    page: 1,
    size: 10,
    name: null,
    mobile: null,
    branchId: null,
    emiratesId: null,
    cardSerialNumber: null,
    fromDate: null,
    toDate: null,
    applicationId: 1,
  };
  const [filterForm, setFilterForm] = useState(request);

  useEffect(() => {
    console.log(filterForm);
    if (filterForm) {
      getRejected(filterForm);
    }
  }, [filterForm]);

  const rowClicked = (data) => {
    let states = { ...data, title: "Rejected User" };
    history.push({
      pathname: "/admin/registration-verification",
      state: states,
    });
  };

  const columnsCsv = [
    { label: "Date", key: "rejectedDate" },
    { label: "Full Name", key: "fullName" },
    { label: "Mobile Number", key: "phoneNumber" },
    { label: "Branch Id", key: "branchId" },
    { label: "Company Name", key: "companyName" },
    { label: "Emirates ID", key: "emiratesId" },
    { label: "Card Serial Number", key: "cardSerialNo" },
  ];

  const rowOnClick = {
    onClick: (e, row, rowIndex) => {
      rowClicked(row);
    },
  };

  const columns = [
    {
      dataField: "",
      text: "",
      sort: false,
      style: { minWidth: "50px", textAlign: "center" },
      formatter: (cell, row) => {
        return (
          <>
            <i
              style={{ fontSize: 18 }}
              className="fas fa-search"
              onClick={() => {
                rowClicked(row);
              }}
            />
          </>
        );
      },
    },
    {
      dataField: "citizenId",
      text: "CT ID ",
      sort: false,
      headerStyle: { textAlign: "center" },
      style: { minWidth: "150px", textAlign: "center" },
    },
    {
      dataField: "type",
      text: "Type ",
      sort: false,
      headerStyle: { textAlign: "center" },
      style: { minWidth: "150px", textAlign: "center" },
    },

    {
      dataField: "rejectedDate",
      text: "Date",
      sort: true,
      // headerStyle: { textAlign: "center" },
      style: { minWidth: "100px" },
      formatter: (cell, row) => {
        return moment((row && row.rejectedDate) || null).format("DD-MM-YY");
      },
    },
    {
      dataField: "fullName",
      text: "Full Name",
      sort: false,
      style: { minWidth: "150px", textAlign: "left" },
    },
    {
      dataField: "phoneNumber",
      text: "Mobile Number",
      sort: false,
      headerStyle: { textAlign: "center" },
      style: { minWidth: "150px", textAlign: "center" },
    },
    {
      dataField: "branchId",
      text: "Branch ID",
      sort: false,
      headerStyle: { textAlign: "center" },
      style: { minWidth: "150px", textAlign: "center" },
    },
    {
      dataField: "companyName",
      text: "Company Name",
      sort: false,
      style: { minWidth: "150px", textAlign: "left" },
    },

    {
      dataField: "emiratesId",
      text: "Emirates ID",
      sort: false,
      headerStyle: { textAlign: "center" },
      style: { minWidth: "150px", textAlign: "center" },
    },
    {
      dataField: "cardSerialNo",
      text: "Card Serial Number",
      sort: true,
      style: { minWidth: "200px", textAlign: "center" },
      headerStyle: { textAlign: "center" },
    },
  ];

  const getRejected = (request) => {
    request.size = sizeShow || 10;

    setDataLoading(true);
    getAllRejectedList(request)
      .then((res) => {
        setDataLoading(false);
        console.log({ res });
        if (res && res.data && res.data.users.length > 0) {
          setAllUserList(res.data.users);
        } else {
          setAllUserList([]);
        }
        setPagination({
          ...pagination,
          pageSize: sizeShow || 10,
          total: res.data.totalCount,
          current: request.page,
        });
      })
      .catch((err) => {
        setDataLoading(false);
        setAllUserList([]);
        setPagination({ ...pagination, pageSize: 10, total: 0, current: 1 });
      });
  };

  const handleFIlter = () => {
    let request = {};

    if (searchBy === "name") {
      request = {
        ...filterForm,
        name: searchByValue.trim(),
        mobile: null,
        branchId: null,
        emiratesId: null,
        cardSerialNumber: null,
      };
    } else if (searchBy === "mobile") {
      request = {
        ...filterForm,
        mobile: searchByValue.trim(),
        name: null,
        branchId: null,
        emiratesId: null,
        cardSerialNumber: null,
      };
    } else if (searchBy === "branchId") {
      request = {
        ...filterForm,
        branchId: searchByValue.trim(),
        mobile: null,
        name: null,
        emiratesId: null,
        cardSerialNumber: null,
      };
    } else if (searchBy === "emiratesId") {
      request = {
        ...filterForm,
        emiratesId: searchByValue.trim(),
        mobile: null,
        name: null,
        branchId: null,
        cardSerialNumber: null,
      };
    } else if (searchBy === "cardSerialNumber") {
      request = {
        ...filterForm,
        cardSerialNumber: searchByValue.trim(),
        mobile: null,
        name: null,
        branchId: null,
        emiratesId: null,
      };
    } else if (searchBy === "ctid") {
      request = {
        ...filterForm,
        citizenId: searchByValue.trim(),
        mobile: null,
        name: null,
        branchId: null,
        emiratesId: null,
      };
    }

    request.fromDate =
      (fromDate && moment(fromDate).format("YYYY-MM-DD")) || null;
    request.toDate =
      (toDate && moment(toDate).format("YYYY-MM-DD")) || moment().format();
    request.searchFilter = "";
    request.page = 1;

    setFilterForm(request);
  };

  let searchByValuePlaceholder = "";
  if (searchBy === "name") {
    searchByValuePlaceholder = "Ahmed";
  } else if (searchBy === "mobile") {
    searchByValuePlaceholder = "971xxxxxxxxx";
  } else if (searchBy === "branchId") {
    searchByValuePlaceholder = "99999";
  } else if (searchBy === "emiratesId") {
    searchByValuePlaceholder = "784xxxxxxxxxxxx";
  } else if (searchBy === "ctid") {
    searchByValuePlaceholder = "784xxxxxxxxxxxx";
  } else {
    searchByValuePlaceholder = "1234567890";
  }

  const [pagination, setPagination] = useState({
    pageSize: 10,
    total: 0,
    current: 1,
  });

  const resetFilter = () => {
    setAllUserList([]);
    setallUserListExcel([]);
    setFromDate(null);
    setToDate(null);
    setFilterValues(false);
    setSearchByValue("");
    setSearchBy("mobile");
    setFilterForm(request);
  };

  const onExcelClciked = (filterForm) => {
    let request = filterForm;
    request.page = "";
    request.size = "";
    getAllRejectedList(request)
      .then((res) => {
        console.log({ res });
        if (res && res.data && res.data.users.length > 0) {
          let data = res.data.users.map((element) => {
            if (element.blockDate) {
              element.blockDate = moment(element.blockDate).format(
                "DD-MM-YYYY"
              );
            }
            return element;
          });
          setallUserListExcel(data);
          buttonRef.current.click();
        } else {
          setallUserListExcel([]);
        }
      })
      .catch((err) => {
        console.log({ err });
        setallUserListExcel([]);
      });
  };

  const dateFormat = "DD-MM-YY";
  const customFormat = (value) => `${value.format(dateFormat)}`;
  return (
    <>
      <Container fluid>
        <NkHeader title="Rejections" />
        <Card>
          <CardBody>
            <Row>
              <Col lg="2" className="form-input-padding">
                <FormGroup>
                  <label
                    className="form-control-label"
                    htmlFor="exampleFormControlSelect1"
                  >
                    Search By
                  </label>
                  <Input
                    id="exampleFormControlSelect1"
                    style={{ height: "27px" }}
                    type="select"
                    onChange={(e) => {
                      setSearchByValue("");
                      setSearchBy(e.target.value);
                    }}
                    value={searchBy}
                  >
                    <option value="name">Name</option>
                    <option value="mobile">Mobile</option>
                    <option value="ctid">CT ID</option>
                    <option value="branchId">Branch ID</option>
                    <option value="emiratesId">Emirates ID</option>
                    <option value="cardSerialNumber">Card Serial</option>
                  </Input>
                </FormGroup>
              </Col>
              <Col lg="2" className="form-input-padding">
                <FormGroup>
                  <label
                    className="form-control-label"
                    htmlFor="example3cols2Input"
                  >
                    Search For
                  </label>
                  <Input
                    id="example3cols2Input"
                    style={{ height: "27px" }}
                    type="text"
                    onKeyPress={(e) => e.charCode === 13 && handleFIlter(true)}
                    placeholder={searchByValuePlaceholder}
                    onChange={(e) =>
                      setSearchByValue(e.target.value && e.target.value)
                    }
                    value={searchByValue}
                  />
                </FormGroup>
              </Col>

              <Col lg="2" className="form-input-padding">
                <FormGroup>
                  <Label
                    className="form-control-label"
                    htmlFor="example3cols2Input"
                  >
                    From
                  </Label>
                  <DatePicker
                    placeholder="DD-MM-YY"
                    className="formcontrol-date"
                    onChange={(e, dateString) => {
                      if (dateString && dateString != "") {
                        setFromDate(moment(dateString, dateFormat));
                      } else {
                        setFromDate(null);
                      }
                    }}
                    value={fromDate}
                    format={customFormat}
                  />
                </FormGroup>
              </Col>
              <Col lg="2" className="form-input-padding">
                <FormGroup>
                  <Label
                    className="form-control-label"
                    htmlFor="example3cols2Input"
                  >
                    To
                  </Label>
                  <DatePicker
                    placeholder="DD-MM-YY"
                    className="formcontrol-date"
                    onChange={(e, dateString) => {
                      if (dateString && dateString != "") {
                        setToDate(moment(dateString, dateFormat));
                      } else {
                        setToDate(null);
                      }
                    }}
                    value={toDate}
                    format={customFormat}
                  />
                </FormGroup>
              </Col>

              <Col
                lg="1"
                style={{ marginTop: "9px" }}
                className="form-input-padding"
              >
                <FormGroup>
                  <Label
                    className="form-control-label"
                    htmlFor="example3cols2Input"
                  ></Label>
                  <div>
                    <Button
                      // color="danger"
                      type="button"
                      style={{
                        width: "100%",
                        background: "#e91d24",
                        color: "white",
                        height: "26px",
                        border: "1px solid rgb(233, 29, 36)",
                      }}
                      onClick={() => handleFIlter(true)}
                    >
                      <i className="fas fa-search" />
                    </Button>
                  </div>
                </FormGroup>
              </Col>
              <Col
                lg="1"
                style={{ marginTop: "9px", padding: "0px 6px" }}
                className="form-input-padding"
              >
                <FormGroup>
                  <Label
                    className="form-control-label"
                    htmlFor="example3cols2Input"
                  ></Label>
                  <div>
                    <Button
                      color="light"
                      type="button"
                      style={{ width: "100%", height: "26px" }}
                      id="example3cols2Input"
                      className="filter-button"
                      onClick={() => resetFilter()}
                    >
                      <div
                        style={{
                          fontSize: "12px",
                        }}
                      >
                        {" "}
                        <i class="fas fa-redo-alt 2px"></i> Reset
                      </div>
                    </Button>
                  </div>
                </FormGroup>
              </Col>
            </Row>
          </CardBody>
        </Card>
        {/* {allUserList.length <= 0 ? (
          <>
            <Card
              className="mb-4"
              style={{
                display: "flex",
                flex: 1,
                textAlign: "center",
                justifyContent: "center",
                padding: "1.25rem 1.5rem",
              }}
            >
              <CardBody>
                <h1 className="mb-0"> No Records Found..!</h1>
                
              </CardBody>
            </Card>
          </>
        ) : ( */}
        <>
          <Row>
            <div className="col card-parent">
              <Card style={{ padding: "1.25rem 1.5rem" }}>
                {dataLoading ? (
                  <div style={{ textAlign: "center" }}>
                    <Loading />
                  </div>
                ) : (
                  <>
                    <NkTable
                      dataexcal
                      data={allUserList}
                      dataEXCEL={allUserListExcel}
                      buttonRef={buttonRef}
                      csvLink={csvLink}
                      onExcelClciked={() => onExcelClciked(filterForm)}
                      columns={columns}
                      rowOnClick={rowOnClick}
                      type="rejected"
                      filterdata={filterForm}
                      columnsCsv={columnsCsv}
                      pagination={pagination}
                      showSizeChanged={(pageSize) => {
                        setSizeShow(pageSize);
                        setFilterForm({
                          ...filterForm,
                        });
                      }}
                      onPagechange={(page) => {
                        setFilterForm({ ...filterForm, page: page });
                      }}
                      filename={"Rejected-list"}
                    />
                  </>
                )}
              </Card>
            </div>
          </Row>
        </>
      </Container>
    </>
  );
};

export default Rejected;
